import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-date-filter-help-modal',
  standalone: true,
  imports: [
    CommonModule, 
    TranslatePipe, 
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent, 
    IonButtons, 
    IonButton, 
    IonIcon
  ],
  templateUrl: './date-filter-help-modal.component.html',
  styleUrls: ['./date-filter-help-modal.component.scss']
})
export class DateFilterHelpModalComponent {
  @Output() closeModal = new EventEmitter<void>();

  constructor(
    private modalService: ModalService
  ) {
    addIcons({ close });
  }

  close(): void {
    this.modalService.dismiss();
  }
}